import React from 'react';
import * as classes from './HeroSection.module.scss';
import Container from '../../../../../Common/Container/Container';
import { HomePageHeroSectionProps } from '../../../../../Sections/HomePage/HeroSection/HeroSection';

const HeroSection = ({ longTitle, sectorsList, address }: HomePageHeroSectionProps) => {
  const sectorsMapper = (item: string, index: number) => <li key={index}>{item}</li>;

  return (
    <section className={classes.wrapper}>
      <Container>
        <h1 className={classes.title} data-aos='fade-in'>
          {longTitle}
        </h1>
        <div className={classes.subtitle} data-aos='fade-in' data-aos-delay='300'>
          {address}
        </div>
        <ul className={classes.sectors} data-aos='fade-in' data-aos-delay='600'>
          {sectorsList.map(sectorsMapper)}
        </ul>
      </Container>
    </section>
  );
};

export default HeroSection;
